import {
  CELL_MATCH_MODE_EQUALS,
  normalizeCellMatchMode,
  valuesMatchByMode,
} from "./cellMatchModeUtils";
import {
  normalizeColumnDefaultGroups,
  serializeColumnDefaultGroups,
} from "./columnDefaultRulesUtils";

export const resolveSkipColumn = (column, headerLabels = null) => {
  const normalized = String(column || "").trim();
  if (!normalized || /^\d+$/.test(normalized)) {
    return normalized;
  }
  if (!headerLabels) {
    return normalized;
  }
  const target = normalized.toLowerCase();
  const matchedKey = Object.entries(headerLabels).find(
    ([, label]) => String(label).trim().toLowerCase() === target,
  )?.[0];
  return matchedKey != null ? String(matchedKey) : normalized;
};
export const skipCellValuesMatch = (left, right, mode = CELL_MATCH_MODE_EQUALS) => (
  valuesMatchByMode(left, right, mode)
);

export const normalizeRowSkipRules = (rules) => (
  Array.isArray(rules)
    ? rules
      .filter((rule) => rule && String(rule.column || "").trim())
      .map((rule) => ({
        column: String(rule.column).trim(),
        value: rule.value == null ? "" : String(rule.value),
        mode: normalizeCellMatchMode(rule.mode),
      }))
    : []
);

export const DEFAULT_SCHEDULED_ENABLED = true;

export const normalizeScheduledEnabled = (value) => {
  if (value === false || value === 0 || value === "false" || value === "0" || value === "no" || value === "off") {
    return false;
  }
  return true;
};

export const rowMatchesSkipRule = (row, rules, headerLabels = null) => {
  if (!row || !rules?.length) {
    return false;
  }
  return rules.some((rule) => {
    const column = resolveSkipColumn(rule.column, headerLabels);
    return column && skipCellValuesMatch(row[column], rule.value, rule.mode);
  });
};

export const buildMappingRulesPayload = (
  mapping,
  rowSkip,
  columnCount = 0,
  { scheduledEnabled = DEFAULT_SCHEDULED_ENABLED, columnDefaults = {} } = {},
) => {
  const numericKeys = Object.keys(mapping || {}).filter((key) => /^\d+$/.test(key));
  const resolvedCount = columnCount || (numericKeys.length ? Math.max(...numericKeys.map(Number)) : 0);
  const columnMapping = resolvedCount > 0
    ? Array.from({ length: resolvedCount }, (_, index) => mapping[String(index + 1)] || "skip")
    : Object.keys(mapping || {})
      .sort((a, b) => Number(a) - Number(b))
      .map((key) => mapping[key] || "skip");

  return {
    column_mapping: columnMapping,
    row_skip: normalizeRowSkipRules(rowSkip),
    scheduled_enabled: normalizeScheduledEnabled(scheduledEnabled),
    column_defaults: serializeColumnDefaultGroups(columnDefaults),
  };
};
